var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 200,
    viewBox: "0 0 251 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.71 65C211.576 65 214.71 68.134 214.71 72C214.71 75.866 211.576 79 207.71 79H167.71C171.576 79 174.71 82.134 174.71 86C174.71 89.866 171.576 93 167.71 93H189.71C193.576 93 196.71 96.134 196.71 100C196.71 103.866 193.576 107 189.71 107H179.536C174.662 107 170.71 110.134 170.71 114C170.71 116.577 172.71 118.911 176.71 121C180.576 121 183.71 124.134 183.71 128C183.71 131.866 180.576 135 176.71 135H93.71C89.844 135 86.71 131.866 86.71 128C86.71 124.134 89.844 121 93.71 121H54.71C50.844 121 47.71 117.866 47.71 114C47.71 110.134 50.844 107 54.71 107H94.71C98.576 107 101.71 103.866 101.71 100C101.71 96.134 98.576 93 94.71 93H69.71C65.844 93 62.71 89.866 62.71 86C62.71 82.134 65.844 79 69.71 79H109.71C105.844 79 102.71 75.866 102.71 72C102.71 68.134 105.844 65 109.71 65H207.71ZM207.71 93C211.576 93 214.71 96.134 214.71 100C214.71 103.866 211.576 107 207.71 107C203.844 107 200.71 103.866 200.71 100C200.71 96.134 203.844 93 207.71 93Z",
    fill: "#DCE8F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.21 133C139.712 133 154.71 118.002 154.71 99.5C154.71 80.9985 139.712 66 121.21 66C102.708 66 87.71 80.9985 87.71 99.5C87.71 118.002 102.708 133 121.21 133Z",
    fill: "#DCE8F4",
    stroke: "#0072CE",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.842 125.494C117.601 125.819 119.39 125.987 121.21 126C135.846 126 147.71 114.136 147.71 99.5C147.71 84.8645 135.846 73 121.21 73C117.45 73 113.874 73.7829 110.634 75.1946C105.004 77.6479 100.392 81.9999 97.6059 87.4419C95.7545 91.0589 94.71 95.1575 94.71 99.5C94.71 103.44 95.5698 107.179 97.1121 110.54C98.2132 112.94 99.6621 115.146 101.394 117.096",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.842 125.494C117.601 125.819 119.39 125.987 121.21 126C135.846 126 147.71 114.136 147.71 99.5C147.71 84.8645 135.846 73 121.21 73C117.45 73 113.874 73.7829 110.634 75.1946C105.004 77.6479 100.392 81.9999 97.6059 87.4419C95.7545 91.0589 94.71 95.1575 94.71 99.5C94.71 103.44 95.5698 107.179 97.1121 110.54C98.2132 112.94 99.6621 115.146 101.394 117.096",
    stroke: "#0072CE",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.507 120.075C106.655 121.821 109.082 123.237 111.711 124.247",
    stroke: "#0072CE",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.71 126L154.71 132",
    stroke: "#0072CE",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.74 131.03C151.848 132.923 151.848 135.992 153.74 137.884L164.826 148.97C166.718 150.862 169.787 150.862 171.68 148.97C173.572 147.077 173.572 144.008 171.68 142.116L160.594 131.03C158.702 129.138 155.633 129.138 153.74 131.03Z",
    fill: "#F6F7F9",
    stroke: "#0072CE",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.71 133L169.71 144",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.71 88C114.71 99.598 124.112 109 135.71 109C137.988 109 140.182 108.637 142.236 107.966C138.883 116.287 130.732 122.161 121.21 122.161C108.695 122.161 98.5493 112.015 98.5493 99.5C98.5493 88.1596 106.88 78.7648 117.755 77.1011C115.823 80.2793 114.71 84.0097 114.71 88Z",
    fill: "#F6F7F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.71 81C120.437 81 119.192 81.1253 117.989 81.3642M114.355 82.4761C107.514 85.3508 102.71 92.1144 102.71 100",
    stroke: "#0072CE",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.886 99.7773H166.71M181.21 92H164.034H181.21ZM188.21 92H185.989H188.21Z",
    stroke: "#0072CE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8857 121.777H76.71M80.21 113H63.0342H80.21ZM57.21 113H52.9888H57.21Z",
    stroke: "#0072CE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NotFound.29a2d1ccdb9cb03286e37f75a9b31f99.svg";